<div
  class="signup-wrapper"
  [class.mobile]="isMobile()"
  [class.tablet]="isTablet()"
>
  <div class="signup-image">
    @if (isDesktop()) {
      <img
        nz-image
        nzDisablePreview
        nzSrc="assets/images/login_image.jpg"
        alt="login"
        height="100%"
      />
    } @else {
      <img
        nz-image
        nzDisablePreview
        nzSrc="assets/images/login_image_mobile.jpg"
        alt="login-mobile"
        width="100%"
      />
    }
  </div>
  <div class="signupForm">
    @if (isLoading()) {
      <div class="spinner-container">
        <app-spinner [black]="true"></app-spinner>
      </div>
    } @else {
      <div class="innersignup">
        <div class="header-signup">
          <img
            nz-image
            class="logo"
            alt="logo"
            nzDisablePreview
            nzSrc="assets/images/LoctitePulseLogo_red.svg"
          />
          <h1>{{ i18n.langString("create_account") }}</h1>
          <p>{{ i18n.langString("create_account_info") }}</p>
        </div>
        @if (error()) {
          <p class="error">
            {{ i18n.langString("signup_failed") }}
          </p>
        }
        <app-common-form
          [isAdmin]="false"
          (formSubmit)="createUser($event)"
          [formConfigureInput]="signUpFormConfig"
          [countryList]="countryArray()"
          [submitText]="'Submit Form'"
          [captchaEnabled]="cfg.enableCaptcha"
        >
          @if (!country()) {
            <span class="us-canada"
              ><nz-icon nzType="icons:info" nzTheme="outline" />
              {{ i18n.langString("uscountry") }}
              <a
                [routerLink]="['/signup']"
                [queryParams]="{ country: 'us' }"
                routerLinkActive="active"
                target="_blank"
                class="linkColor"
                >here.</a
              ></span
            >
          }
          @if (country()) {
            <span class="us-canada"
              ><nz-icon nzType="icons:info" nzTheme="outline" />
              <span>{{ i18n.langString("notuscountry") }}</span>
              <a
                [routerLink]="['/signup']"
                routerLinkActive="active"
                target="_blank"
                class="linkColor"
                >here.</a
              ></span
            >
          }
        </app-common-form>
        <div class="submitButtonWrapper signupButtonSlim installationAgentBtn">
          <app-nav-button
            [lighttertiary]="true"
            svgIcon="icons:login"
            (clickEvent)="goToLoginPage()"
          >
            {{ i18n.langString("already_account") }}
          </app-nav-button>
        </div>
      </div>
    }
  </div>
</div>
